module.exports = __webpack_public_path__ + "static/media/img_homepage_logo-NA-mobile.1175a0bb.png";